import {
  watch
} from "./chunk.HBM5K2JV.js";
import {
  __decorateClass,
  component_styles_default,
  theme_styles_default
} from "./chunk.U4VUMZVF.js";

// src/components/icon/icon.ts
import { html, LitElement } from "lit";
import { property, state } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";
import { unsafeSVG } from "lit/directives/unsafe-svg.js";

// src/components/icon/library/yotpo-icons.library.ts
import { YotpoIcons } from "@yotpo-common/icons";
var YotpoIconsLibrary = {
  name: "YotpoIconsLibrary",
  type: "source" /* source */,
  resolver: (name) => {
    const nameStabilized = name.trim();
    const icon = YotpoIcons[nameStabilized];
    if (!icon) {
      console.error(`Icon with name ${name} was not found in the library. Please check list of all available icons on https://fe-infra.yotpo.xyz/icons/index.html`);
    }
    return icon;
  }
};

// src/components/icon/library/library.ts
var registry = [YotpoIconsLibrary];
var watchedIcons = [];
function watchIcon(icon) {
  watchedIcons.push(icon);
}
function unwatchIcon(icon) {
  watchedIcons = watchedIcons.filter((el) => el !== icon);
}
function getIconLibrary(name) {
  return registry.filter((lib) => lib.name === name)[0];
}

// src/components/icon/icon.styles.ts
import { css } from "lit";
var icon_styles_default = css`
	${theme_styles_default}
	${component_styles_default}

	:host {
		display: inline-block;
		width: 1em;
		height: 1em;
		contain: strict;
		box-sizing: content-box !important;
	}

	.icon,
	svg {
		fill: currentColor;
		display: block;
		height: 100%;
		width: 100%;
	}
`;

// src/components/icon/icon.ts
var YotpoIcon = class extends LitElement {
  constructor() {
    super(...arguments);
    this.svg = "";
    this.label = "";
    this.library = "YotpoIconsLibrary";
  }
  connectedCallback() {
    super.connectedCallback();
    watchIcon(this);
  }
  firstUpdated() {
    this.setIcon();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    unwatchIcon(this);
  }
  async getUrl() {
    const library = await getIconLibrary(this.library);
    return library.resolver(this.name);
  }
  redraw() {
    this.setIcon();
  }
  async setIcon() {
    const library = getIconLibrary(this.library);
    if (!library.type || library.type === "source" /* source */) {
      this.svg = await this.getUrl();
    }
  }
  handleChange() {
    this.setIcon();
  }
  render() {
    const hasLabel = typeof this.label === "string" && this.label.length > 0;
    return html` <div
			part="base"
			class="icon"
			role=${ifDefined(hasLabel ? "img" : void 0)}
			aria-label=${ifDefined(hasLabel ? this.label : void 0)}
			aria-hidden=${ifDefined(hasLabel ? void 0 : "true")}
		>
			${unsafeSVG(this.svg)}
		</div>`;
  }
};
YotpoIcon.componentName = "Icon";
YotpoIcon.styles = icon_styles_default;
__decorateClass([
  state()
], YotpoIcon.prototype, "svg", 2);
__decorateClass([
  property({ reflect: true })
], YotpoIcon.prototype, "name", 2);
__decorateClass([
  property({ reflect: true })
], YotpoIcon.prototype, "label", 2);
__decorateClass([
  watch("name"),
  watch("library")
], YotpoIcon.prototype, "setIcon", 1);
if (!customElements.get("yotpo-icon")) {
  customElements.define("yotpo-icon", YotpoIcon);
}

export {
  YotpoIcon
};
